import styled from "styled-components";

export const UnitTitleInput = styled.input`
  width: 90%;
  font-family: "DM Sans";
  font-size: 20px;
  font-weight: 300;
  line-height: 19px;
  margin-bottom: 5px;
  height: 40px;
  /* min-height: calc(34px); */
  border: none;
  /* border-bottom: 1px solid lightgray;
  padding: 5px 10px; */
  color: black;
  background-color: #f8f8f8;
  &:focus {
    border: none;
    border-bottom: 1px solid lightgray;
    outline: none;
  }
  &::placeholder {
    color: red;
  }
`;
export const UnitContainer = styled.div`
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  margin: 10px 0;
`;

export const UnitTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* height: 40px; */
  background-color: #f8f8f8;
  width: 95%;
  font-family: "Nunito";
  padding: 10px;
`;

export const UnitTitle = styled.h2`
  font-size: 20px;
  font-weight: 300;
  margin: 0;
`;
export const UnitIndex = styled.div`
  font-size: 20px;
  font-family: "Nunito";
  font-weight: 300;
  margin: 0;
  margin-right: 10px;
  /* height: 40px; */
  width: 5%;
  background-color: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OptionType = styled.div`
  list-style: none;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 300;
  padding: 5px 10px;
  &:hover {
    cursor: pointer;
    background: gray;
    color: white;
  }
`;

export const OptionContainer = styled.div`
  width: 100%;
  height: fit-content;
  background: #f8f8f8;
  z-index: 10;
  padding: 10px;
  border-radius: 5px;
`;
